import loginModule from "../loginModule.js";
import { EnvironmentUrls } from "Roblox";

function loginService(httpService, loginConstants) {
    "ngInject";

    function getApiUrl(endpoint) {
        return EnvironmentUrls.authApi + endpoint;
    }

    function getAppSiteUrl(endpoint) {
        return EnvironmentUrls.authAppSite + endpoint;
    }

    function getApiGatewayUrl(endpoint) {
        return EnvironmentUrls.apiGatewayUrl + endpoint;
    }

    function getAuthTokenMetadata() {
        var url = getApiGatewayUrl(loginConstants.urls.authTokenMetadata);
        var urlConfig = {
            url: url
        };

        return httpService.httpGet(urlConfig);
    }

    function login(params) {
        var url = getApiUrl(loginConstants.urls.loginApi);
        var urlConfig = {
            url: url
        };

        return httpService.httpPost(urlConfig, params, true);
    }

    function canVerifyCredentials(params) {
        var url = getApiUrl(loginConstants.urls.credentialsVerificationApi);
        var urlConfig = {
            url: url
        };

        return httpService.httpGet(urlConfig, params, true);
    }

    function verifyCredentials(params) {
        var url = getApiUrl(loginConstants.urls.credentialsVerificationSendApi);
        var urlConfig = {
            url: url
        };

        return httpService.httpPost(urlConfig, params, true);
    }

    function setReturnUrl(returnUrl) {
        window.Roblox.Auth = window.Roblox.Auth || {};
        window.Roblox.Auth.returnUrl = returnUrl;
    }

    function getReturnUrl() {
        return window.Roblox.Auth && window.Roblox.Auth.returnUrl;
    }

    var loginService = {
        login: login,
        canVerifyCredentials: canVerifyCredentials,
        verifyCredentials: verifyCredentials,
        setReturnUrl: setReturnUrl,
        getReturnUrl: getReturnUrl,
        getAuthTokenMetadata: getAuthTokenMetadata
    };
    return loginService;
}

loginModule.factory("loginService", loginService);

export default loginService;